module.exports = __webpack_public_path__ + "static/intercom-integration3-db0dbf8dde70fede6acae9212c5222d1.png";